export const NAV_ITEMS = [
  { label: "INICIO", path: "/" },
  { label: "ACTUALIDAD", path: "/actualidad" },
  { label: "CULTURAS", path: "/culturas" },
  { label: "HISTORIAS", path: "/historias" },
  { label: "SOCIEDAD", path: "/sociedad" },
  { label: "MUNDO", path: "/mundo" },
  { label: "ESPECIALES", path: "/especiales" },
  { label: "MULTIMEDIA", path: "/multimedia" },
  { label: "OPINIÓN", path: "/opinion" },
  { label: "QUIÉNES SOMOS", path: "/quienes-somos" },
];

export const CATEGORY_META = {
  actualidad: { label: "Actualidad", color: "#FF6B35", tagline: "Lo que pasa, cuando y donde pasa.",
    desc: "Acontecimientos, instituciones, derechos y vida comunitaria." },
  culturas: { label: "Culturas", color: "#0055FF", tagline: "Identidades, tradiciones y diversidad.",
    desc: "Colectividades, inmigración, gastronomía, lenguas y patrimonio." },
  historias: { label: "Historias", color: "#8A2BE2", tagline: "Voces reales, historias que inspiran.",
    desc: "Historias de vida, familias, migrantes y testimonios." },
  sociedad: { label: "Sociedad", color: "#FF6B35", tagline: "Derechos, convivencia y desafíos comunes.",
    desc: "Derechos humanos, inclusión, convivencia y diálogo social." },
  mundo: { label: "Mundo", color: "#0055FF", tagline: "Miradas globales, impactos locales.",
    desc: "Conflictos, migraciones, diásporas y derechos humanos." },
  especiales: { label: "Especiales", color: "#8A2BE2", tagline: "Periodismo de profundidad.",
    desc: "Investigaciones, informes, documentales y coberturas especiales." },
  multimedia: { label: "Multimedia", color: "#FF6B35", tagline: "Videos, podcasts y documentales.",
    desc: "Videos, entrevistas, podcast, documentales, galerías y transmisiones." },
  opinion: { label: "Opinión", color: "#0055FF", tagline: "Columnas de análisis y reflexión.",
    desc: "Columnas de opinión de nuestros columnistas e invitados." },
};

export const CONTACT_INFO = {
  email: "nexodumnoticias@gmail.com",
  youtube: "https://www.youtube.com/@NexodumNoticias",
};

export const SOCIALS = [
  { name: "YouTube", key: "youtube", url: "https://www.youtube.com/@NexodumNoticias" },
  { name: "Instagram", key: "instagram", url: "" },
  { name: "Facebook", key: "facebook", url: "" },
  { name: "TikTok", key: "tiktok", url: "" },
  { name: "X", key: "x", url: "" },
];

export const TYPE_LABELS = {
  noticia: "Noticia", reportaje: "Reportaje", opinion: "Opinión",
  investigacion: "Investigación", entrevista: "Entrevista", video: "Video",
};

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("es-AR", { day: "numeric", month: "long", year: "numeric" });
  } catch { return ""; }
}

export function formatTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit" });
  } catch { return ""; }
}
